import { render, staticRenderFns } from "./distributor-box.vue?vue&type=template&id=32195fc5"
import script from "./distributor-box.vue?vue&type=script&lang=js"
export * from "./distributor-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports